import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
/**
 * Quick "what did I just add?" reference, opened on demand rather than
 * kept permanently visible (per explicit feedback) - the full findings
 * list sorts by label/name, so a species just logged can land anywhere in
 * it, easy to lose track of while adding several in a row. Shows only the
 * 10 most recently created findings for this exhibition, asked of the API
 * on opening (the page itself only has the rows scrolled to) -
 * canonical/scientific name + author + label/no if set, nothing else: a
 * glance-check, not a full row.
 */
export default class RecentFindingsModal extends Modal {
  findings = null;
  failed = false;
  oninit(vnode) {
    super.oninit(vnode);
    app.store.find('champis-exhibitions-findings', {
      filter: {
        exhibition: this.attrs.exhibition.id()
      },
      sort: '-createdAt',
      page: {
        limit: 10
      }
    }, undefined, {
      errorHandler: () => {}
    }).then(findings => this.findings = [...findings]).catch(() => this.failed = true).finally(() => m.redraw());
  }
  className() {
    return 'Modal--small ChampisRecentFindingsModal';
  }
  title() {
    return app.translator.trans('champis-exhibitions.forum.recent_findings_modal.title');
  }
  content() {
    const t = key => app.translator.trans(`champis-exhibitions.forum.recent_findings_modal.${key}`);
    if (this.failed) return m("div", {
      className: "Modal-body"
    }, t('error'));
    if (!this.findings) return m(LoadingIndicator, null);
    const recent = this.findings;
    return m("div", {
      className: "Modal-body"
    }, recent.length === 0 ? m("p", {
      className: "ChampisRecentFindingsModal-empty"
    }, t('empty')) : m("ul", {
      className: "ChampisRecentFindingsModal-list"
    }, recent.map(finding => {
      const display = finding.speciesDisplay();
      const name = finding.gbifId() === 0 ? t('undetermined') : display ? display.canonicalName || display.scientificName : t('unknown_species');
      return m("li", {
        key: finding.id()
      }, finding.label() && m("span", {
        className: "ChampisRecentFindingsModal-no"
      }, finding.label()), m("em", null, name), " ", display && display.author);
    })));
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/RecentFindingsModal', RecentFindingsModal);